export default __webpack_public_path__ + "static/media/shirt14.3f29d693.jpeg";